var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"dg_state",staticClass:"flex items-center t-[#646A73]"},[_c('span',{staticClass:"status-icon mr-[5]",class:_vm.status}),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }